import StructuredData from './StructuredData'

export default StructuredData
